<template>
    <span class="flex items-center text-xs tablet-sm:text-base leading-7 text-secondary-text underline">
        <ChevronRightIcon class="h-3 w-3 mx-2" />
        <span><slot></slot></span>
    </span>
</template>
<script setup>
import { ChevronRightIcon } from "@heroicons/vue/24/outline";
</script>
